import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { selectObjects, selectObject } from '../../../../ducks/editor/objects'

import {
  getLaunchComponentId,
  getAuthComponentId,
  setLaunchComponentId,
  setAuthComponentId,
} from '../../../../ducks/apps'

import DraggableIndicator from './DraggableIndicator'
import './LaunchComponent.css'

class LaunchComponentIndicator extends Component {
  render() {
    const {
      launchComponent,
      authComponent,
      zoom,
      match,
      setLaunchComponentId,
      setAuthComponentId,
      objects,
    } = this.props

    const { appId } = match.params

    return (
      <div className="launch-component-indicators">
        <DraggableIndicator
          appId={appId}
          component={launchComponent}
          zoom={zoom}
          onChangeComponent={setLaunchComponentId}
          name="Returning User"
          type="home"
          offset={20}
          objects={objects}
        />
        <DraggableIndicator
          appId={appId}
          component={authComponent}
          zoom={zoom}
          onChangeComponent={setAuthComponentId}
          name="New User"
          type="auth"
          offset={-20}
          objects={objects}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  launchComponent: selectObject(
    state,
    getLaunchComponentId(state, match.params.appId)
  ),
  authComponent: selectObject(
    state,
    getAuthComponentId(state, match.params.appId)
  ),
  objects: selectObjects(state),
})

export default withRouter(
  connect(mapStateToProps, {
    setLaunchComponentId,
    setAuthComponentId,
  })(LaunchComponentIndicator)
)
